// extracted by mini-css-extract-plugin
export default {"section":"SectionWrapper_section__if9ky","topNone":"SectionWrapper_topNone__HDC0t","bottomNone":"SectionWrapper_bottomNone__8viES"};